// Quay lại màn đồng ý OAuth sau khi đăng nhập (pages/OAuthConsentPage.jsx).
//
// LoginPage dùng chung của cnv-ui KHÔNG đọc `location.state.from` — sau đăng nhập nó đi theo `redirectTo` của host
// (/select-workspace hoặc /dashboard) ⇒ người bấm «Kết nối» trong Claude đăng nhập xong rơi vào dashboard, yêu cầu
// OAuth mất, Claude chờ mãi. Màn đồng ý cất đường quay lại vào sessionStorage TRƯỚC khi đưa sang /login; redirectTo
// của LoginPage (pages/LoginPage.jsx) đọc nó. Chỉ nhận đúng đường /oauth/authorize?… — không thành cửa chuyển hướng tuỳ ý.
const KEY = 'cnv.oauth.return';
const PREFIX = '/oauth/authorize?';

export function rememberOAuthReturn(path) {
  try { if (String(path).startsWith(PREFIX)) sessionStorage.setItem(KEY, path); } catch { /* chế độ riêng tư */ }
}

/** Đọc mà KHÔNG xoá: redirectTo có thể chạy nhiều lượt render; màn đồng ý tự xoá khi đã vào được. */
export function peekOAuthReturn() {
  try {
    const v = sessionStorage.getItem(KEY);
    return v && v.startsWith(PREFIX) ? v : null;
  } catch { return null; }
}

export function clearOAuthReturn() {
  try { sessionStorage.removeItem(KEY); } catch { /* bỏ qua */ }
}
